import Link from "next/link";
import type { HelpAudience } from "~/lib/help-center-search";
import { cn } from "~/lib/utils";

const PILL_CLASS =
  "rounded-full px-4 py-1.5 text-sm font-medium transition-colors";

/**
 * Shared across all three `/podrska` entry points, including the therapist
 * gate, so the switcher never disappears depending on who is signed in.
 */
export function AudienceSwitcher({ audience }: { audience?: HelpAudience }) {
  const tabs = [
    { href: "/podrska", label: "Sve", isActive: !audience },
    {
      href: "/podrska/klijenti",
      label: "Klijenti",
      isActive: audience === "client",
    },
    {
      href: "/podrska/terapeuti",
      label: "Terapeuti",
      isActive: audience === "therapist",
    },
  ];

  return (
    <nav className="shrink-0 sm:ml-auto" aria-label="Odaberi publiku">
      <div className="inline-flex rounded-full bg-muted p-1">
        {tabs.map((tab) => (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={tab.isActive ? "page" : undefined}
            className={cn(
              PILL_CLASS,
              tab.isActive
                ? "bg-background text-foreground shadow-xs"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
